import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'
import * as dimensionFilter from '../../../../../../shared/dimension-filter'

/**
 * Organization filter for the unassigned sponsored accounts.
 */
@ngCore.Component({
  imports: [
    dimensionFilter.Component,
    ds.button.Component,
    ds.overlay.slideout.Component,
  ],
  selector: 'atn-space-unassigned-sponsored-accounts-filters',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.unassignedSponsoredAccounts.Collection} */
  public readonly unassignedSponsoredAccountsEc = ngCore.inject(
    state.space.full.unassignedSponsoredAccounts.Collection,
  )

  /** Current List plugin that owns the edited filters. */
  public readonly currentListPlugin =
    this.unassignedSponsoredAccountsEc.plugins.currentListPlugin

  /** Organization dimension-filter plugin owned by the collection. */
  public readonly organizationDimensionFilterPlugin =
    this.unassignedSponsoredAccountsEc.plugins
      .lookup(
        state.space.full.unassignedSponsoredAccounts.plugins
          .organizationDimensionFilter.Plugin,
      )
      .get()

  /** Applies the Current List draft parameters and closes the slideout. */
  public applyClickHandler(): void {
    this.currentListPlugin.feature.actions.applyParams
      .from('Space.UnassignedSponsoredAccounts.Filters.Apply.Clicked')
      .dispatch()
  }

  /** Discards the Current List draft parameters and closes the slideout. */
  public cancelClickHandler(): void {
    this.currentListPlugin.feature.actions.discardParams
      .from('Space.UnassignedSponsoredAccounts.Filters.Cancel.Clicked')
      .dispatch()
  }

  /** Clears the Current List draft filters without closing the slideout. */
  public resetClickHandler(): void {
    this.currentListPlugin.editedParams.actions.setFilters
      .from('Space.UnassignedSponsoredAccounts.Filters.Reset.Clicked')
      .dispatch({})
  }
}
